class ComponentShare {
  constructor() {
    this._init();
  }

  _init() {
    // Partage sur Facebook
    // document.getElementById('facebookShare')?.addEventListener('click', () => {
    //   const pageUrl: string = encodeURIComponent(window.location.href);
    //   const facebookUrl: string = `https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`;
    //   window.open(facebookUrl, '_blank', 'width=600,height=400');
    //   console.log(facebookUrl);
    // });

    // Partage sur X (Twitter)
    // document.getElementById('twitterShare')?.addEventListener('click', () => {
    //   const pageUrl = encodeURIComponent(window.location.href);
    //   const twitterUrl = `https://twitter.com/intent/tweet?url=${pageUrl}`;
    //   this.openShareWindow(twitterUrl);
    // });

    // Partage sur LinkedIn
    // document.getElementById('linkedinShare')?.addEventListener('click', () => {
    //   const pageUrl = encodeURIComponent(window.location.href);
    //   const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${pageUrl}`;
    //   this.openShareWindow(linkedinUrl);
    // });

    // Copier le lien
    document.getElementById('copyLink')?.addEventListener('click', () => {
      const currentUrl = window.location.href;

      navigator.clipboard
        .writeText(currentUrl)
        .then(() => {
          // Afficher la notification
          const notification = document.getElementById('copyNotification');
          if (notification) {
            notification.style.display = 'inline-block';
            notification.style.opacity = '1';

            // Masquer la notification après 2 secondes
            setTimeout(() => {
              notification.style.opacity = '0';
              setTimeout(() => (notification.style.display = 'none'), 300);
            }, 2000);
          }
        })
        .catch(err => {
          console.error('Impossible de copier le lien :', err);
        });
    });
  }

  openShareWindow(url: string): void {
    window.open(url, '_blank');
  }
}

export const componentShare = new ComponentShare();
